import {User} from "@/oauth/User";
import {UserDto} from "@/oauth/UserDto";
import {SecurityUtils} from "@/oauth/SecurityUtils";
import {MessageJiGuangUserBody} from "@/entity/MessageJiGuangUserBody";
import {JiGuangDto} from "@/dto/JiGuangDto";

export class JiGuang {
    static user = new User();

    static onDeviceReady() {
        document.addEventListener("jpush.receiveRegistrationId", (event) => {
            console.log("receiveRegistrationId" + JSON.stringify(event));
        }, false);
        JiGuang.initJPush();
    }

    static initJPush() {
        if ('JPush' in window) {
            console.log('initialize JPush...');
            try {
                const win: any = window

                const JPush = win.JPush
                JPush.init();
                JPush.setDebugMode(true);
                window.setTimeout(() => {
                    JPush.getRegistrationID((data: any) => {
                        console.log(data);
                        try {
                            this.user.gongHao = data;
                            UserDto.save(this.user);
                            // alert('JPush initialize successful...,registion is'+data);
                        } catch (e) {
                            console.log(e);
                        }

                    });
                }, 1000);
            } catch (exception) {
                console.log(exception);
            }
        } else {
            console.log('JPush is not exist...');
        }
    }

    static async getUser() {
        JiGuang.user = await UserDto.findByUsername(SecurityUtils.getLoginUser().username);
    }

    static mount() {
        JiGuang.getUser();
        document.addEventListener("deviceready", JiGuang.onDeviceReady, false);
    }

    static async sendPush(jidUsername: string, name: string, message: string) {
        const messageJiGuangUserBody = new MessageJiGuangUserBody();
        messageJiGuangUserBody.message = message;
        messageJiGuangUserBody.jidUsername = jidUsername;
        messageJiGuangUserBody.name = name;
        try {
            await JiGuangDto.sendMessage(messageJiGuangUserBody);
        } catch (e) {
            console.log(e);
        }
    }

}
